import { getAccountAuthStateForMailboxInfo, StateTypeEnum } from 'owa-account-authstate-store';
import { isSignInRequired } from 'owa-app-auth-ui-store';
import type { MailboxInfo } from 'owa-client-types';
import { isMsalFlowEnabled } from 'owa-msaljs/lib/isMsalFlowEnabled';

export const hasAuthError = (mailboxInfo: MailboxInfo): boolean =>
    (isMsalFlowEnabled() && isSignInRequired()) ||
    getAccountAuthStateForMailboxInfo(mailboxInfo).stateType !== StateTypeEnum.NoError;
